import { Component, OnInit } from '@angular/core';
import { DashboardsFiltersModel } from 'src/app/models/filters/implementations/pageFilters/dashboardsFilters.model';
import { PageWithFiltersEnum } from 'src/app/models/filters/pageWithFilters.enum';
import { ISelectOption } from 'src/app/models/selectOptions';
import { FiltersService } from 'src/app/services/filters/filters.service';

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss'],
})
export class DashboardFiltersComponent implements OnInit {
  public readonly pageFilters = this._filtersService.getFilters(
    PageWithFiltersEnum.Dashboards
  ) as DashboardsFiltersModel;

  public selectedOptions: ISelectOption[] = [];

  constructor(private readonly _filtersService: FiltersService) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.subscribe(() => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();
    });
  }

  public tablesFiltersChange(selectedOptions: ISelectOption[]) {
    this.pageFilters.updateFilterFromUserSelection(undefined, selectedOptions);
  }
}
